import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../state/metaPixel/metaPixel.utils';

export default function MetaPixelPageTracker() {
  const location = useLocation();

  useEffect(() => {
    trackPageView();
  }, [location.pathname, location.search]);

  return null;
}
